const SIN_DATO = 'campo vacio';

const valueOrDefault = (value) => {
  if (value === null || value === undefined) return SIN_DATO;
  const text = String(value).trim();
  return text || SIN_DATO;
};

const porcentaje = (cantidad, total) => {
  if (!total) return 0;
  return Math.round((cantidad * 10000) / total) / 100;
};

const ordenarRanking = (items) => {
  return items.sort((a, b) => {
    if (b.cantidad !== a.cantidad) return b.cantidad - a.cantidad;
    return a.nombre.localeCompare(b.nombre);
  });
};

const contarPorCampo = (contactos, campoNombre, campoId) => {
  const mapa = {};

  contactos.forEach((contacto) => {
    const id = campoId ? valueOrDefault(contacto[campoId]) : valueOrDefault(contacto[campoNombre]);
    const nombre = valueOrDefault(contacto[campoNombre]);

    if (!mapa[id]) {
      mapa[id] = {
        id,
        nombre,
        cantidad: 0,
      };
    }

    mapa[id].cantidad += 1;
  });

  return ordenarRanking(Object.values(mapa)).map((item) => ({
    ...item,
    porcentaje: porcentaje(item.cantidad, contactos.length),
  }));
};

const contarPorDia = (contactos) => {
  const mapa = {};

  contactos.forEach((contacto) => {
    const fecha = contacto.fecha_de_contacto ? String(contacto.fecha_de_contacto).split('T')[0] : SIN_DATO;

    if (!mapa[fecha]) {
      mapa[fecha] = {
        id: fecha,
        nombre: fecha,
        cantidad: 0,
      };
    }

    mapa[fecha].cantidad += 1;
  });

  return ordenarRanking(Object.values(mapa)).map((item) => ({
    ...item,
    porcentaje: porcentaje(item.cantidad, contactos.length),
  }));
};

export const reportes_contactos = (contactos = []) => {
  const lista = Array.isArray(contactos) ? contactos : [];
  const asesores = contarPorCampo(lista, 'asesor_name', 'asesor_id');
  const areas = contarPorCampo(lista, 'area_interes_name', 'area_interes_id');
  const origenes = contarPorCampo(lista, 'origen', 'origen_id');
  const programas = contarPorCampo(lista, 'programa_interes_name', 'programa_interes_id');
  const profesiones = contarPorCampo(lista, 'profesion_name');
  const estados = contarPorCampo(lista, 'estado');
  const dias = contarPorDia(lista);

  // Agrupar los peores asesores (los 3 niveles/cantidades más bajas)
  const cantidadesUnicas = Array.from(new Set(asesores.map(a => a.cantidad))).sort((a, b) => a - b);
  const peoresCantidades = cantidadesUnicas.slice(0, 3);
  const peoresAsesoresAgrupados = peoresCantidades.map((cantidad, idx) => ({
    rango: idx + 1,
    cantidad,
    asesores: asesores.filter(a => a.cantidad === cantidad),
  }));

  return {
    total: lista.length,
    asesores,
    podium: asesores.slice(0, 3),
    peoresAsesoresAgrupados,
    areas,
    origenes,
    programas,
    profesiones,
    estados,
    dias,
    destacados: {
      asesor: asesores[0] || null,
      area: areas[0] || null,
      origen: origenes[0] || null,
      programa: programas[0] || null,
      profesion: profesiones[0] || null,
      estado: estados[0] || null,
      dia: dias[0] || null,
    },
  };
};
